import { createFileRoute, Link } from '@tanstack/react-router';
import { Card } from '@ds/components/core/Card';
import { Icon } from '@ds/components/core/Icon';
import { AuthenticatedShell, Page } from '@/components/AppShell';
import { buildMoreNav } from '@/components/nav-items';
import { useSession } from '@/features/auth/api';

export const Route = createFileRoute('/_authenticated/configuracoes')({ component: SettingsPage });

function slug(label: string): string {
  return label.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, '-');
}

/** Aba "Outros" do mobile (0021): lista tudo que estava no menu hambúrguer e não é
 * uma das abas fixas (Início/Transações). */
function SettingsPage() {
  const { data: session } = useSession();
  const items = buildMoreNav(session?.transactionsViewMode);
  return (
    <AuthenticatedShell title="Outros">
      <Page>
        <Card>
          <nav aria-label="Mais opções" data-testid="settings-menu">
            <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
              {items.map((item, index) => (
                <li key={item.to} style={{ borderTop: index === 0 ? 'none' : '1px solid var(--border-subtle)' }}>
                  <Link
                    to={item.to}
                    data-testid={`settings-link-${slug(item.label)}`}
                    style={{ display: 'flex', alignItems: 'center', gap: 12, minHeight: 52, padding: '0 16px', textDecoration: 'none', font: 'var(--type-label)', color: 'var(--text-primary)' }}
                  >
                    <Icon name={item.icon} size={18} />
                    <span style={{ flex: 1 }}>{item.label}</span>
                    <Icon name="chevron-right" size={16} style={{ color: 'var(--text-subtle)' }} />
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </Card>
      </Page>
    </AuthenticatedShell>
  );
}
